export const setToken = (token) => {
  return localStorage.setItem('JWT', token);
};
export const removeToken = (token) => {
  return localStorage.removeItem('JWT');
};

export const getToken = () => {
  return localStorage.getItem('JWT');
};

export const setItem = (name, item) => {
  return localStorage.setItem(name, item);
};

export const getItem = (name) => {
  return localStorage.getItem(name);
};
